import script from "./EsportRegions.vue?vue&type=script&setup=true&lang=js"
export * from "./EsportRegions.vue?vue&type=script&setup=true&lang=js"

import "./EsportRegions.vue?vue&type=style&index=0&id=01d31864&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01d31864"]])

export default __exports__